import { CheckoutState } from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { PartnerBF, ServiceBF } from '../../../models'
// import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import AddressResetTemplate from './template'
import { useBFSM } from '../../../contexts/bfsmContext'
import { Booking, Package, Partner, Product } from '@raskrask-dk/raskrask-utils'

const AddressResetPage = (): ReactElement => {
    const [BFSM] = useBFSM()

    const data = BFSM.getData<CheckoutState>()
    const product = data.product
    const getPatner = (product: Product | undefined): Partner | undefined => {
        switch (product?.type) {
            case 'Booking':
                return (product as Booking).partner
            case 'Package':
                return (product as Package).partner
            case 'CompanyLead':
                return undefined
            default:
                return undefined
        }
    }
    const partner = getPatner(product)
    const address = data.address
    const serviceType = data.product.service

    const isFreeConsultation = serviceType
        ? (serviceType as ServiceBF).freeConsultation
        : false

    const onClickReset = () => {
        window.location.reload()
    }

    return (
        <AddressResetTemplate
            address={address!.address}
            onClickReset={onClickReset}
            partner={partner! as PartnerBF}
            isFreeConsultation={isFreeConsultation}
        />
    )
}

export default AddressResetPage
